export const PHOTO_URL = process.env.REACT_APP_PHOTO_URL;
